import { PersonSerializer } from "@models/serializers/personSerializer.ts";
import { httpRequest } from "../../http";
import { Person } from "@models/person.model.ts";

export class CommandDeleteProfilePicture {
  async run(personId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/person/${personId}/profile-picture/`;

    try {
      const response = await httpRequest<any>(url, { method: "DELETE" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Person {
    const serializer = new PersonSerializer();
    return serializer.deserialize(data);
  }
}
